export default __webpack_public_path__ + "static/media/slider9.2bfc0342.jpg";